import script from "./HelpPageAPI.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpPageAPI.vue?vue&type=script&setup=true&lang=js"

import "./HelpPageAPI.vue?vue&type=style&index=0&id=7cd57aba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cd57aba"]])

export default __exports__